import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

import type { CancelPendingRolesOutcome } from '../hooks/useTeamApi';

// Shared by the Team table row menu and the edit tray `PendingRoleBanner`.
export const cancelPendingRoleMessages = defineMessages({
  revokeAdminAccess: {
    id: 'Team.cancelPendingRole.revokeAdminAccess',
    defaultMessage: 'Revoke admin access',
    description:
      'Action that revokes the newly granted admin role of an existing member while it is still waiting out its delay before it starts',
  },
  cancellationPending: {
    id: 'Team.cancelPendingRole.cancellationPending',
    defaultMessage: 'Revoking admin access. This can take a few minutes.',
    description:
      'Toast shown after "Revoke admin access" when the backend recorded the cancellation but has not finished it yet',
  },
  roleChangeCancelled: {
    id: 'Team.cancelPendingRole.roleChangeCancelled',
    defaultMessage: 'Role change cancelled.',
    description:
      'Toast shown after the newly granted role of a member (e.g. Admin) was cancelled before it started',
  },
});

/** Toast copy for a successful "Revoke admin access". */
export function getCancelPendingRoleSuccessMessage(
  outcome: CancelPendingRolesOutcome,
): MessageDescriptor {
  if (outcome === 'cancellation_pending') return cancelPendingRoleMessages.cancellationPending;
  return cancelPendingRoleMessages.roleChangeCancelled;
}
